import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow.icon-49a8e0",
  "use": "arrow.icon-49a8e0-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow.icon-49a8e0\">\n<path d=\"M5.5 9.67391L13 17.5L20.5 9.67391\" stroke=\"var(--svg-primary-color)\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol